import { InvoicesTable } from "@/features/invoices/invoices-table";

const InvoicesScreen = () => {
  return (
    <div className="p-4">
      <InvoicesTable />
    </div>
  );
};

export default InvoicesScreen;
